"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledColumnHeader = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("../../../assets/styles/config");
exports.StyledColumnHeader = styled_components_1.default.th `
  color: ${config_1.colors.purpleText} !important;
  font: bold ${config_1.fontSizes.tiny} ${config_1.fontFamilies.primary};
  padding: ${(props) => (props.modal ? '1rem 5px !important' : '1rem')};
  width: ${(props) => (props.width ? props.width : '20%')};
`;
